var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmentPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 81 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.459,
    y: 1.72412,
    width: 42.9358,
    height: 64.4037,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.50488,
    y: 17.9629,
    width: 47.3395,
    height: 48.1651,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 66.1279H1",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0917 10.1655H1",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.50391,
    y: 10.1655,
    width: 8.31804,
    height: 7.79817,
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8223,
    y: 10.1655,
    width: 8.31804,
    height: 7.79817,
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1406,
    y: 10.1655,
    width: 8.31804,
    height: 7.79817,
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6787,
    y: 53.0083,
    width: 10.4587,
    height: 13.1193,
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5321 17.9629H1V24.2014H44.4862V40.7152H1V46.9537H59.5321V17.9629Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.9629V17.2129H0.25V17.9629H1ZM59.5321 17.9629H60.2821V17.2129H59.5321V17.9629ZM1 24.2014H0.25V24.9514H1V24.2014ZM44.4862 24.2014H45.2362V23.4514H44.4862V24.2014ZM44.4862 40.7152V41.4652H45.2362V40.7152H44.4862ZM1 40.7152V39.9652H0.25V40.7152H1ZM1 46.9537H0.25V47.7037H1V46.9537ZM59.5321 46.9537V47.7037H60.2821V46.9537H59.5321ZM1 18.7129H59.5321V17.2129H1V18.7129ZM1.75 24.2014V17.9629H0.25V24.2014H1.75ZM1 24.9514H44.4862V23.4514H1V24.9514ZM43.7362 24.2014V40.7152H45.2362V24.2014H43.7362ZM44.4862 39.9652H1V41.4652H44.4862V39.9652ZM1.75 46.9537V40.7152H0.25V46.9537H1.75ZM59.5321 46.2037H1V47.7037H59.5321V46.2037ZM58.7821 17.9629V46.9537H60.2821V17.9629H58.7821Z",
    fill: "#808080"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.50391,
    y: 24.2026,
    width: 37.9817,
    height: 16.5138,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentPremium);
export default __webpack_public_path__ + "static/media/equipment_premium.bc188c671a41556abf8a55528321fc12.svg";
export { ForwardRef as ReactComponent };